import { createSlice } from '@reduxjs/toolkit';
import { getCustomerById } from './customerMiddleware';
import { type Customer, type LoanDetails, type Deposit, type SaleDetails } from './customerTypes';

interface InitialState {
  loading: boolean;
  customers: Customer[];
  customer: Customer;
  loan: LoanDetails;
  deposits: Deposit[];
  sales: SaleDetails;
}

const initialState: InitialState = {
  loading: false,
  customers: [],
  customer: {
    name: '',
    dob: new Date(),
    aadhar: '',
    nominee: '',
    drivingLicenseNumber: '',
    address: '',
    branch: '',
    phoneNumber: '',
    alternatePhoneNumber: '',
    photo: '',
    mail: '',
    permanentAddress: '',
    proofPhoto: '',
    area: '',
    pincode: '',
    fatherName: ''
  },
  loan: {
    activeLoan: [],
    closedLoan: [],
    cashPending: [],
    approvals: [],
    rejected: []
  },
  deposits: [],
  sales: {
    activeSale: [],
    closedSale: [],
    cashPending: [],
    approvals: [],
    rejected: []
  }
};

const customerReducer = createSlice({
  name: 'counter',
  reducers: {
    resetCustomerState(state) {
      state.customer = initialState.customer;
      state.loan = initialState.loan;
      state.deposits = initialState.deposits;
      state.sales = initialState.sales;
    },
  },
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getCustomerById.fulfilled, (state, action) => {
      state.customer = action.payload;
      
      state.loan.activeLoan = action.payload.loans.filter((x: any) => x.status === 'active');
      state.loan.closedLoan = action.payload.loans.filter((x: any) => x.status === 'closed');
      state.loan.cashPending = action.payload.loans.filter((x: any) => x.status === 'cash_disbursement');
      state.loan.approvals = action.payload.loans.filter((x: any) => (x.status === 'admin_approval_pending') || (x.status === 'manager_approval_pending'));
      state.loan.rejected = action.payload.loans.filter((x: any) => x.status === 'rejected');

      // Filter deposits that are not archived
      state.deposits = action.payload.deposits?.filter((x: any) => x.archived === false) ?? [];

      // Filter sales by status
      state.sales.activeSale = action.payload.sales?.filter((x: any) => x.status === 'active') ?? [];
      state.sales.closedSale = action.payload.sales?.filter((x: any) => x.status === 'closed') ?? [];
      state.sales.cashPending = action.payload.sales?.filter((x: any) => x.status === 'cash_disbursement') ?? [];
      state.sales.approvals = action.payload.sales?.filter((x: any) => (x.status === 'admin_approval_pending') || (x.status === 'manager_approval_pending')) ?? [];
      state.sales.rejected = action.payload.sales?.filter((x: any) => x.status === 'rejected') ?? [];
    });
  },
});

export const { resetCustomerState } = customerReducer.actions;
export default customerReducer.reducer;
